import { render, staticRenderFns } from "./ContentBlockHTML.vue?vue&type=template&id=095cf802&"
import script from "./ContentBlockHTML.vue?vue&type=script&lang=js&"
export * from "./ContentBlockHTML.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports